export const messages = {
  en: {
    activitiesSignUpManage: {
      search: {
        title: 'Search Conditions',
        activitiesId: 'Please enter activity ID',
        titlePlaceholder: 'Please enter title',
        typeCd: 'Please select activity type',
        staffName: 'Please enter publisher name',
        startTime: 'Please enter start time',
        endTime: 'Please enter end time'
      },
      list: {
        title: 'Activity List'
      },
      table: {
        signUpId:'Sign Up ID',
        activitiesId: 'Activity ID',
        activitiesTitle: 'Activity Title',
          userName: 'User Name',
          userTel:'User Tel',
          peopleCount:'People Count',
          stateName:'State Name',
          createTime: 'Create Time'
      },
      add: {
        title: 'Add Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        signUpStartTime: 'sign up start time',
        signUpEndTime: 'sign up end time',
        typeCdPlaceholder: 'Required, please select type',
        isMoreCommunity: 'Multi-community',
        isMoreCommunityPlaceholder: 'Please select if multi-community',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        context: 'Content'
      },
      edit: {
        title: 'Edit Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        signUpStartTime: 'sign up start time',
        signUpEndTime: 'sign up end time',
        typeCdPlaceholder: 'Required, please select type',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        context: 'Content'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this data?'
      },
      validate: {
        titleRequired: 'Title is required',
        titleMaxLength: 'Title cannot exceed 200 characters',
        typeCdRequired: 'Type is required',
        headerImgRequired: 'Header image is required',
        contextRequired: 'Content is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        signUpStartTimeRequired: 'Sign up start time is required',
        signUpEndTimeRequired: 'Sign up end time is required',
        activitiesIdRequired: 'Activity ID is required',
        imageSize: 'Image size cannot exceed 2MB'
      }
    }
  },
  zh: {
    activitiesSignUpManage: {
      search: {
        title: '活动报名查询',
        activitiesId: '请输入活动ID',
          userName:'请输入姓名',
          userTel:'请输入电话',
          state:'请选择报名状态',
        titlePlaceholder: '请输入标题',
        typeCd: '请选择活动类型',
        staffName: '请输入发布人名称',
        startTime: '请输入开始时间',
        endTime: '请输入结束时间'
      },
      list: {
        title: '活动报名列表'
      },
      table: {
        signUpId:'报名ID',
        activitiesId: '活动ID',
        activitiesTitle: '活动标题',
          userName: '姓名',
          userTel:'电话',
          peopleCount:'人数',
          stateName:'状态',
          createTime: '报名时间'
      },
      add: {
        title: '添加活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        typeCdPlaceholder: '必填，请选择类型',
        isMoreCommunity: '多小区',
        isMoreCommunityPlaceholder: '请选择是否多小区',
        headerImg: '头图(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        context: '内容',
        signUpStartTime: '报名开始时间',
        signUpEndTime: '报名结束时间',
        signUpStartTimePlaceholder: '必填，请输入报名开始时间',
        signUpEndTimePlaceholder: '必填，请输入报名结束时间',
      },
      edit: {
        title: '编辑活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        typeCdPlaceholder: '必填，请选择类型',
        headerImg: '头图(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        startTime: '开始时间',
        endTime: '结束时间',
        context: '内容',
        signUpStartTime: '报名开始时间',
        signUpEndTime: '报名结束时间',
        signUpStartTimePlaceholder: '必填，请输入报名开始时间',
        signUpEndTimePlaceholder: '必填，请输入报名结束时间',
      },
      delete: {
        title: '确认操作',
        confirmText: '确认删除该报名吗？'
      },
      validate: {
        titleRequired: '标题不能为空',
        titleMaxLength: '标题不能超过200个字符',
        typeCdRequired: '类型不能为空',
        headerImgRequired: '头部照片不能为空',
        contextRequired: '内容不能为空',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空',
        signUpStartTimeRequired: '报名开始时间不能为空',
        signUpEndTimeRequired: '报名结束时间不能为空',
        activitiesIdRequired: '活动ID不能为空',
        imageSize: '图片大小不能超过2MB'
      }
    }
  }
}